import { DateTime } from 'luxon';
import update from 'immutability-helper';
import { formatRawPhoneNumber } from '../../lib/utils/phoneNumber';
import UserRole from '../../lib/sdk/kUserRoles';
import { PSYCH_NOTE_SETTINGS_KEYS } from '../constants';
export var formatPatientDetails = function (patient) {
    var _a;
    var details = '';
    try {
        if (patient.ageInYears) {
            details = patient.ageInYears + " y/o";
        }
        if (patient.gender) {
            details = details + " " + patient.gender;
        }
        if (patient.phoneNumber) {
            details = details + " " + formatRawPhoneNumber(patient.phoneNumber);
        }
    }
    catch (error) {
        (_a = window.rollbar) === null || _a === void 0 ? void 0 : _a.error(error);
    }
    return details;
};
export var formatDate = function (date, timeZone, isNoteHeader) {
    var _a;
    var dateString = '';
    if (date) {
        try {
            var string = date.toString();
            dateString =
                DateTime.fromISO(string, { zone: 'utc' })
                    .setZone(timeZone)
                    .toLocaleString(DateTime.DATE_SHORT) || string;
        }
        catch (error) {
            (_a = window.rollbar) === null || _a === void 0 ? void 0 : _a.error(error);
            if (isNoteHeader) {
                throw new Error(error);
            }
        }
    }
    return dateString;
};
export var formatDateTime = function (date, timeZone) {
    var _a;
    var dateString = '';
    try {
        if (date && timeZone) {
            var convertedTime = convertUtcToTimeZone(date, timeZone) || '';
            if (convertedTime !== '') {
                dateString = 'Last Saved: ' + convertedTime;
            }
        }
    }
    catch (error) {
        (_a = window.rollbar) === null || _a === void 0 ? void 0 : _a.error(error);
    }
    return dateString;
};
function convertUtcToTimeZone(utcTimeString, targetZone) {
    var _a;
    var formattedDate = '';
    try {
        if (targetZone) {
            var utcDateTime = DateTime.fromISO(utcTimeString, { zone: 'utc' });
            var targetDateTime = utcDateTime.setZone(targetZone);
            formattedDate = targetDateTime.toFormat('h:mm a');
        }
    }
    catch (error) {
        formattedDate = 'Error converting time.';
        (_a = window.rollbar) === null || _a === void 0 ? void 0 : _a.error(error);
    }
    return formattedDate;
}
export var formatUserName = function (user) {
    var _a;
    var userString = '';
    if (user) {
        try {
            userString = user.firstName + " " + user.lastName;
        }
        catch (error) {
            (_a = window.rollbar) === null || _a === void 0 ? void 0 : _a.error(error);
            throw new Error(error);
        }
    }
    return userString;
};
export var returnToNotesList = function (patientId) {
    window.location.href = "/notes-ui/#/notes-list/" + patientId;
};
// Psych Notes are disabled by default unless provider is Mental Health specialty or has psychNotesEnabled = true in user settings
export var isPsychNotesEnabled = function (settings) {
    var _a;
    if (PSYCH_NOTE_SETTINGS_KEYS.enabled in settings) {
        return !!((_a = settings === null || settings === void 0 ? void 0 : settings.value) === null || _a === void 0 ? void 0 : _a.psychNotesEnabled);
    }
    return false;
};
export var isAboutDialogDismissed = function (settings) {
    var _a;
    if (settings.value && PSYCH_NOTE_SETTINGS_KEYS.dismissed in (settings === null || settings === void 0 ? void 0 : settings.value)) {
        return !!((_a = settings === null || settings === void 0 ? void 0 : settings.value) === null || _a === void 0 ? void 0 : _a.aboutDialogDismissed);
    }
    return false;
};
// if this check returns null then the caller needs to check Mental Health Speciality of the user
export var checkPsychNotesEnabled = function (settings) {
    var _a;
    return !!((_a = settings === null || settings === void 0 ? void 0 : settings.value) === null || _a === void 0 ? void 0 : _a.psychNotesEnabled);
};
export var validateIdNumber = function (id) {
    return Number.parseInt(id) || 0;
};
// If psych notes user settings returns 404, need to return a default object that can be used for merging on update for About Dialog
export var getDefaultPsychNoteUserSettings = function () {
    return { value: { aboutDialogDismissed: false } };
};
export var getDisabledPsychNoteUserSettings = function () {
    return {
        id: null,
        createdAt: null,
        updatedAt: null,
        value: { psychNotesEnabled: false, aboutDialogDismissed: false },
    };
};
export var updatePsychNoteEnabledValueInSettings = function (settings, updatedValue) {
    return update(settings, {
        value: {
            $merge: { psychNotesEnabled: updatedValue },
        },
    });
};
export var isProvider = function (userObj) {
    if (userObj) {
        return userObj === null || userObj === void 0 ? void 0 : userObj.roles.includes(UserRole.PROVIDER);
    }
    return false;
};
export var isMedicationsClicked = function (clickedDiv) {
    var _a;
    return (clickedDiv &&
        (clickedDiv.className.includes('med-list') || ((_a = clickedDiv.parentElement) === null || _a === void 0 ? void 0 : _a.className.includes('med-list'))));
};
